import { GoogleMap, InfoWindow, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';

import InfoWindowContent from './infowindow';
import React from 'react';
import googleIcon from '../../../../pages/images/iconchartlogo.png';
import youarehere from '../../../../pages/images/youarehere.png';

const gmdv = require(`../../../../ghc_config`);

const LocationsMap = withScriptjs(withGoogleMap((props) =>{
  
  let centerMap = true;
  let spherical = google.maps.geometry.spherical; 
  let distanceMiles = props.radius
  let closerPlace = props.locations.length ? props.locations[0].node.distance : distanceMiles

  if (closerPlace > distanceMiles) {
    distanceMiles = closerPlace
    let newRadius = props.radius
    if (distanceMiles > 100) {
      newRadius = 150000
    } else if (distanceMiles > 75) {
      newRadius = 100
    } else if (distanceMiles > 50) {
      newRadius = 75
    } else if (distanceMiles > 25) {
      newRadius = 50
    } else if (distanceMiles > 10) {
      newRadius = 25     
    } 
    props.handleRadiusChange(newRadius)
  }

  distanceMiles = gmdv.sphericalDistance(distanceMiles);

  return (
      <GoogleMap
        ref={(map) => {
          if (map != null)
          {     
            const bounds = new window.google.maps.LatLngBounds();

            if(props.stateCheck !== null){
              const geocoder = new google.maps.Geocoder();
              geocoder.geocode( { 'address': props.stateCheck}, function(results, status) {
                 if (status == google.maps.GeocoderStatus.OK) {
                    map.fitBounds(results[0].geometry.viewport);
                 }
                 else {
                    bounds.extend(spherical.computeOffset(new google.maps.LatLng(props.startPosition), distanceMiles, 0));
                    bounds.extend(spherical.computeOffset(new google.maps.LatLng(props.startPosition), distanceMiles, -90));
                    bounds.extend(spherical.computeOffset(new google.maps.LatLng(props.startPosition), distanceMiles, 180));
                    bounds.extend(spherical.computeOffset(new google.maps.LatLng(props.startPosition), distanceMiles, 90));
                 }
               })
            }
            else {
              bounds.extend(spherical.computeOffset(new google.maps.LatLng(props.startPosition), distanceMiles, 0));
              bounds.extend(spherical.computeOffset(new google.maps.LatLng(props.startPosition), distanceMiles, -90));
              bounds.extend(spherical.computeOffset(new google.maps.LatLng(props.startPosition), distanceMiles, 180));
              bounds.extend(spherical.computeOffset(new google.maps.LatLng(props.startPosition), distanceMiles, 90));
            }

            map.fitBounds(bounds);
          }
        }}
        //center={props.startPosition}
        defaultOptions={{
          mapTypeControl: true,
          streetViewControl: true,
          zoomControl: true,
          fullscreenControl: false,
          minZoom: gmdv.minZoom,
          maxZoom: gmdv.maxZoom,
        }}
      >
        {props.locations.length && props.locations.map((place, i) => {

          props.locations[i].node.relationships.field_image_carousel[0] &&
          props.locations[i].node.relationships.field_image_carousel[0].localFile.childImageSharp

          if (place.node.field_latitude && place.node.field_longitude) {

            let WindowPosition = {
              lat: Number(place.node.field_latitude),
              lng: Number(place.node.field_longitude),
            };

            let address_sl = ``
            if(place.node.field_address_fl) {
              address_sl = `${place.node.field_city}, ${gmdv.selectState(place.node.field_state).spa} ${place.node.field_zip}`
            }

            let distance = place.node.distance;
            distance = Number((distance).toFixed(1));
            (distance != 0) ? centerMap = false: null
            let address = place.node.field_address_fl + '\n' + address_sl;
            let geolocation = geolocation = {lat: Number(place.node.field_latitude), lng: Number(place.node.field_longitude)}
          
            return (
              <Marker
                key={i}
                zIndex={i}
                uid={place.uid}
                position={geolocation}
                center={geolocation}
                defaultAnimation={google.maps.Animation.DROP}
                onClick={() => props.handleToggleOpen(place)}
                icon={{url: googleIcon}}
              >
                {props.positionWindow &&
                props.positionWindow.lat == place.node.field_latitude && 
                props.positionWindow.lng == place.node.field_longitude && 
                  <InfoWindow
                    position={WindowPosition}
                    onCloseClick={() => props.handleToggleCloseAll()}
                  >
                    <InfoWindowContent
                      locationName={place.node.title}
                      locationPath={place.node.path.alias}
                      redirects={place.node.field_center_group}
                      locationAddress={address}
                      CarouselImages={props.locations[i].node.relationships.field_image_carousel[0].localFile.childImageSharp}
                      distance={distance}
                      //  starsdata
                      allPracticemaxRatings={props.allPracticemaxRatings}
                    />
                  </InfoWindow>
                }
              </Marker>
            )
          }
        })}
        {(!centerMap && props.searchtype === 'location') &&
          <Marker
            position={props.startPosition}
            center={props.startPosition}
            defaultAnimation={google.maps.Animation.DROP}
            icon={{url: youarehere}}
            zIndex={999}
          />}
      </GoogleMap>
    );
  }
))

export default LocationsMap;